import { HTMLAttributes, useEffect } from 'react';

import { SERVER_ENV } from '~constant/env';
import { isClient } from '~utils/lodash/isServer';

import { BANNER_SIZE } from './constants';
import * as S from './style';

export interface GoogleAdsBannerProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * 구글문서 참고
   * @link https://support.google.com/admanager/answer/1100453?hl=en
   * - leaderBoard: 728 x 90
   * - medium rectangle: 300 x 136
   * - mobile banner: 300 x 50
   */
  bannerType: 'leaderBoard' | 'mediumRectangle' | 'mobileBanner';
  slotId: string;
}

export default function GoogleAdsBanner({ bannerType, slotId, ...props }: GoogleAdsBannerProps) {
  useEffect(() => {
    if (isClient && SERVER_ENV === 'production') {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }
  }, []);

  return (
    <S.Wrapper bannerType={bannerType} {...props}>
      <ins
        className='adsbygoogle'
        style={{ display: 'inline-block', ...BANNER_SIZE[bannerType] }}
        data-ad-client='ca-pub-7810616757902075'
        data-ad-slot={slotId}></ins>
    </S.Wrapper>
  );
}
